import * as React from 'react'

import { DrawerBase } from './DrawerBase'

type TDrawerProps = Omit<PropsOf<typeof DrawerBase>, 'isFullHeight'>

type TProps = RequiredChildren & TDrawerProps

/**
 * drawer opening from the bottom side of the page,
 * mainly useful for presenting additional information on small devices,
 * for desktop, consider using Modal instead
 */
export const BottomDrawer: React.FC<TProps> = ({ children, ...drawerProps }) => {
  return (
    <DrawerBase
      {...drawerProps}
      headerProps={{
        overContent: true,
        ...drawerProps.headerProps,
      }}
    >
      {children}
    </DrawerBase>
  )
}
